import { render, staticRenderFns } from "./DebugTool.vue?vue&type=template&id=bdcc0610&scoped=true&"
import script from "./DebugTool.vue?vue&type=script&lang=js&"
export * from "./DebugTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcc0610",
  null
  
)

export default component.exports